'use client'

import { motion } from 'motion/react'
import React from 'react'

export const ArtistMotionSection = () => {
  return (
    <div className="w-full h-full relative flex justify-center items-center">
      <motion.img
        src="/img/home/hosoo_main.png"
        alt="캐릭터"
        className="w-full h-fit top-[98px]"
        style={{
          aspectRatio: '281.37/303.39',
        }}
      />
    </div>
  )
}
